import ExternalLink from 'components/generic/ExternalLink.component';
import S from 'constants/string.const';
import { useHelpLinks } from 'hooks/useHelpLinks.hook';
import { useTranslation } from 'providers/GILT.provider';

export const TextThankYou = () => {
  const { t } = useTranslation();
  const { googleReviewHelpLink, facebookReviewHelpLink } = useHelpLinks();

  return (
    <div data-bem="TextThankYou">
      {S.space}
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section4Description1Part2')}
        <p>
          <span role="img" aria-labelledby="lamp">
            {S.lamp}
            {S.space}
          </span>
          {t('clientConnect.section4Description2Part1')}
          {S.space}
          <span role="img" aria-labelledby="lamp">
            {S.lamp}
          </span>
          {S.space}
          {t('clientConnect.section4Description2Part2')}
          <ExternalLink link={googleReviewHelpLink} variant="card">
            {t('clientConnect.googleLink')}
          </ExternalLink>
          {t('clientConnect.section4Description2Part3')} <span className="break-line" />
          {t('clientConnect.section4Description2Part4')}
          <ExternalLink link={facebookReviewHelpLink} variant="card">
            {t('clientConnect.facebookLink')}
          </ExternalLink>
        </p>
      </div>
    </div>
  );
};
